<template>
  <div class="page home">
    <div class="page-header">
      <button class="header-nav-btn" @click="$parent.$refs.nav.open()" aria-label="Open nav menu"></button>

      <span class="page-title">Press</span>
      <HeaderNav />
    </div>

    <div class="page-content" v-if="'id' in pageData">
      <Components :components="pageData.acf.components" location="above" />

      <div class="page-container">
        <h1>{{pageData.title.rendered}}</h1>

        <ul class="press-list">
          <li v-for="press in pageData.acf.press" :key="press.name">
            <p>{{press.date}} <strong>{{press.name}}</strong></p>
            <a :href="press.link.url" :target="press.link.target"><i>{{press.link.title}}</i></a>
          </li>
        </ul>
      </div>

      <Components :components="pageData.acf.components" location="below" />
      <Footer />
    </div>
  </div>
</template>

<script>
import SubPageUtils from '../mixins/SubPageUtils';

import Components from '../components/Components';
import HeaderNav from '../components/HeaderNav';
import Footer from '../components/Footer';

export default {
  name: 'Press',
  components: { Components, HeaderNav, Footer },
  mixins: [SubPageUtils],
  data() {
    return {
      pageData: {},
    }
  },
  async mounted() {
    const pageDataResponse = await fetch(`https://admin.austinstudiotour.org/wp-json/wp/v2/pages/19062`)
    this.pageData = await pageDataResponse.json();
  },
};
</script>

<style scoped lang="less">
@import '../css/variables';

.page-container {
  padding: 50px 20px;
  text-align: center;
}

h1 {
  margin-bottom: 20px;
}

.press-list {
  li {
    margin-bottom: 40px;
    a {
      color: #000;
      text-decoration-color: @themeColor1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Press.vue